export const storagePaginationValues = [10, 25, 50, 100];

export const SPECIAL_TRIGGERS = ["(Webhook)", "(S3 Trigger)"]